export default "__VITE_ASSET__DlB1PbBS__"